const Info = () => import(/* webpackChunkName: "Info" */ "@/views/info/Info");
const InfoList = () => import(/* webpackChunkName: "InfoList" */ "@/views/info/InfoList");
const InfoNew = () => import(/* webpackChunkName: "InfoNew" */ "@/views/info/InfoNew");

const infoRoutes = [
  {
    path: "info",
    name: "Info",
    redirect: {
      name: "Info List"
    },
    component: Info,
    children: [
      {
        path: "list",
        name: "Info List",
        component: InfoList
      },
      {
        path: "new/:section/:order",
        name: "Info New",
        component: InfoNew,
        props: true
      },
      {
        path: "edit/:articleId",
        name: "Info Edit",
        component: InfoNew,
        props: true
      }
    ]
  }
];

export default infoRoutes;